import { Select } from 'antd';
import { times } from 'lodash';
import React, { Component } from 'react';

import colorScales from '../utils/colorScales';

class ColourScaleSelector extends Component {
    constructor(props, context) {
        super(props, context);

        this.containerDiv = React.createRef();
    }

    componentDidMount() {
        this.forceUpdate();
    }

    render() {
        const { onChange, value, colourCount } = this.props;

        const optionWidth = this.containerDiv.current ? this.containerDiv.current.offsetWidth - 22 : 250;
        const containerWidth = this.containerDiv.current && this.containerDiv.current.clientWidth;

        return (
            <div style={{ width: '100%', height: '100%' }} ref={this.containerDiv}>
                <Select value={value} style={{ width: containerWidth, height: 30 }} onSelect={onChange}>
                    {colorScales.map((colour) => {
                        const numberOfPreviewColours = colourCount ? colourCount : 6;

                        return (
                            <Select.Option value={colour.label} key={colour.label} title={' '} style={{ width: '80%' }}>
                                <div
                                    style={{
                                        width: optionWidth - 20,
                                        height: 30,
                                        display: 'grid',
                                        gridTemplateColumns: `repeat(${numberOfPreviewColours}, 1fr)`,
                                    }}
                                >
                                    {times(numberOfPreviewColours, (i) => {
                                        i = i + 1;
                                        return <div key={i} style={{ gridColumn: i, backgroundColor: colour.scale(i / numberOfPreviewColours) }} />;
                                    })}
                                </div>
                            </Select.Option>
                        );
                    })}
                </Select>
            </div>
        );
    }
}

export default ColourScaleSelector;
